/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    position: PropTypes.oneOf(['left', 'right']),
};

const defaultProps = {
    ...commonDefaultProps,
    position: 'right',
};

const ButtonIcon = (props) => {
    const classNames = [
        'c-btn__icon',
        props.position === 'right' ? 'c-btn__icon--right' : '',
        props.position === 'left' ? 'c-btn__icon--left' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

ButtonIcon.propTypes = propTypes;

ButtonIcon.defaultProps = defaultProps;

export default ButtonIcon;
